import * as Blockly from 'blockly/core';
import { useBlockFunctionStore } from '@/stores/useBlockFunctionStore';
import { expr, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['func_call'] = function (block: Blockly.Block): string | [string, number] {
        const fnName: string = (block as any)._fnName ?? '';
        if (!fnName || fnName === '作成した関数') return '';

        const params: { id: string; type: string }[] = (block as any)._params ?? [];
        const args = params.map((_, i) => gen.valueToCode(block, `ARG_${i}`, 0) || '0').join(', ');

        const fn = useBlockFunctionStore.getState().functions.find((f) => f.id === (block as any)._fnId);

        if (fn?.returnType) {
            return expr(`${fnName}(${args})`);
        }

        return stmt(`${fnName}(${args})`);
    };
}
